export const InitializeOnagerDirect = async (conn: any) => {
  return { success: false, method: "unavailable" }
}
